module.exports = {
    FooterLinks: [
        {
            DisplayText: "Privacy Policy",
            TargetType: "unit",
            Metadata:{
                UnitUID: "305c02c3-d58e-4dd9-ad9f-6290602e91f3",
            },
        },
        {
            DisplayText: "About Julie",
            TargetType: "unit",
            Metadata:{
                UnitUID: "060730c9-f137-4759-93d4-c359ec48ba9c",
            },
        },
        {
            DisplayText: "Contact Us",
            TargetType: "unit",
            Metadata: {
                UnitUID: "d07df3cc-c5f5-43af-bcbe-0b59604f5a08",
            },
        },
    ],
};


// WEBPACK FOOTER //
// ./settings/footer-links.js